module.exports = "/dist/images/fr.824ae472.png";